import { Box, Card, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import FamilyInfoForm from './components/FamilyInfoForm';
import PreviousFamilyMemberBanner from './components/PreviousFamilyMemberBanner';
import { ClosedFamilyMemberRef } from '@/api/DTO/family/family.interface';
import PendingMemberLinkAlert from '@/common/components/identity-link/PendingMemberLinkAlert';

export default function FamilyToCreatePage() {
	const { t } = useTranslation();
	const { familyUserId } = useParams();
	const [type, setType] = useState<FormType>(FormType.create);
	// CHA-004: closed family member this applicant re-registers.
	const [closedFamilyMember, setClosedFamilyMember] =
		useState<ClosedFamilyMemberRef | null>(null);
	return (
		<>
			<Box sx={{ width: '100%' }}>
				<Box>
					<Typography variant='h4'>
						{t('drawerListItems.newFamilyMember')}
					</Typography>
					{familyUserId && <PendingMemberLinkAlert userId={familyUserId} />}
					<PreviousFamilyMemberBanner
						value={closedFamilyMember}
						onChange={setClosedFamilyMember}
					/>
					<Card sx={{ marginTop: 3 }}>
						<FamilyInfoForm
							type={type}
							setType={setType}
							closedFamilyMember={closedFamilyMember}
							setClosedFamilyMember={setClosedFamilyMember}
						/>
					</Card>
				</Box>
			</Box>
		</>
	);
}
